import { SensorByProjectModel } from '../models/sensorEntityModels';
import { SensorProjectEntity } from './sensorProjectEntity';

export const SensorsProjectListValueObject = (devicesOptionsList: SensorByProjectModel[]): Readonly<{ list: SensorByProjectModel[] }> => {
  return Object.freeze({
    list: devicesOptionsList.map((item) => SensorProjectEntity(item)),
  });
};
